<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description: 人员页面
 -->
<template>
    <div class="con-f-div">
        <div class="top">
            <el-header class="top-header">
                <div class="header-content">
                    <h3 class="header-content-title">人员管理查询</h3>
                    <el-button class="header-content-btn" @click="shiftFormShow">
                        <icon name="double-arrow-up" class="svg-icon-btn" v-show="formShow"></icon>
                        <icon name="double-arrow-down" class="svg-icon-btn" v-show="!formShow"></icon>
                    </el-button>
                </div>
            </el-header>
            <div class="top-content" v-show="formShow">
                <el-form
                    ref="form"
                    label-position="left"
                    :model="form"
                    label-width="80px"
                    :inline="true"
                >
                    <el-form-item label="用户名称" prop="nickname">
                        <el-input v-model="form.nickname" placeholder="输入用户名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户账号" prop="username">
                        <el-input v-model="form.username" placeholder="输入用户账号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户邮箱" prop="email">
                        <el-input v-model="form.email" placeholder="输入用户邮箱" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="form.status" placeholder="全部" clearable>
                            <el-option label="启用" value="1" key="1"></el-option>
                            <el-option label="禁用" value="0" key="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户角色" prop="roleid">
                        <el-select v-model="form.roleid" placeholder="全部" clearable>
                            <el-option
                                v-for="item in roleList"
                                :value="item.id"
                                :key="item.id"
                                :label="item.name"
                            >{{ item.name }}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户机构" prop="groupId">
                        <div
                            class="select-div-f"
                            @click="showTreeforSelect"
                            style="width:733px"
                            :style="{color:groupName == '全部' ? 'rgb(179,179,179)':'#333'}"
                        >
                            {{groupName}}
                            <el-button
                                icon="el-icon-close"
                                circle
                                class="unit-button"
                                @click.stop="clearDiv"
                                v-if="groupName == '全部' ? false:true"
                            ></el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="top-footer">
                <div class="left-btn">
                    <el-button type="primary" size="small" @click="showDialog()">新增</el-button>
                </div>
                <div class="right-btn">
                    <el-button type="primary" size="small" class="reset-btn" @click="resetForm">重置</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        style="width:70px"
                        @click="loadlist(1)"
                    >查询</el-button>
                </div>
            </div>
        </div>
        <div class="list tab-drive">
            <List
                :title="tableTitle"
                @loadlist="loadlist"
                @showDialog="showDialog"
                @DeleteShow="DeleteShow"
                ref="UserList"
            ></List>
        </div>
        <Add
            @hideDialog="hideDialog"
            @loadTable="loadTable"
            @closeAddModal="closeAddModal"
            @showTree="showTree"
            v-show="isShow"
            ref="Addchild"
            :addTitle="addTitle"
        ></Add>
        <Delete @hideDelete="hideDelete" v-show="isDelete" ref="Deletechild"></Delete>
        <UnitTree
            @hideTree="hideTree"
            @addPage="addPage"
            v-show="isTree"
            v-if="ifTree"
            :isTree="isTree"
            ref="Unitchild"
            :selectUnit="selectUnit"
        ></UnitTree>
    </div>
</template>
<script>
import List from '@/components/UserManagement/List';
import Add from '@/components/UserManagement/Add';
import Delete from '@/components/Delete';
import UnitTree from '@/components/UnitTree';
export default {
    name: 'UserManagement',
    components: {
        List,
        Delete,
        Add,
        UnitTree
    },
    data () {
        return {
            form: {
                nickname: '',
                username: '',
                email: '',
                groupId: '',
                roleid: '',
                status: ''
            },
            groupName: '全部',
            groupChildList: [],
            roleList: [],
            tableTitle: '人员管理列表',
            addTitle: '新增用户',
            isShow: false,
            isDelete: false,
            isTree: false,
            ifTree: false,
            selectLoading: global.loading,
            isSelect: false, // 查询框（true）,“新增”或“编辑”的机构选择框（false）
            formShow: true, // 查询区域显示
            selectUnit: 'all'
        };
    },
    mounted () {
        // this.groupTree()
        this.grtRoleList();
    },
    methods: {
        /**
         * @author: liuc
         * @description:机构树
         * @param {}
         */
        async groupTree () {
            let unitTree = await this.$api.OrganManagement.groupTree();
            this.$store.commit('newGroupTable', unitTree.data);
        },
        /**
         * @author: liuc
         * @description: 关闭删除弹窗
         * @param {}
         */
        hideDelete () {
            this.isDelete = false;
        },
        /**
         * @author: liuc
         * @description:显示新增弹窗
         * @param {}
         */
        DeleteShow () {
            this.isDelete = true;
            this.$refs.Deletechild.open();
        },
        /**
         * @author: liuc
         * @description: 隐藏弹窗
         * @param {}
         */
        hideDialog () {
            this.isShow = false;
        },
        /**
         * @author: liuc
         * @description:显示新增弹窗
         * @param {id} 判断弹窗类型
         */
        showDialog (id) {
            this.isShow = true;
            var type = 0;
            if (id) {
                this.addTitle = '编辑用户';
                type = 1;
            } else {
                this.addTitle = '新增用户';
            }
            this.$refs.Addchild.open(type, id);
        },
        /**
         * @author: liuc
         * @description: 隐藏弹窗
         * @param {}
         */
        hideTree () {
            this.isTree = false;
        },
        /**
         * @author: liuc
         * @description:显示机构弹窗
         * @param {}
         */
        showTree () {
            this.ifTree = true;
            this.isTree = true;
            this.isSelect = false;
        },
        /**
         * @author: liuc
         * @description:清除用户机构
         * @param {}
         */
        clearDiv () {
            this.ifTree = false;
            if (this.isSelect) {
                // 查询框机构
                this.groupName = '全部';
                this.form.groupId = '';
                this.groupChildList = [];
            } else {
                // “新增”或“编辑”选择机构
                this.$refs.Addchild.clearDiv();
            }
        },
        /**
         * @author: liuc
         * @description: 选中机构后点击“确定”
         * @param {unit} 选中机构的内容
         */
        addPage (unit) {
            if (unit.id === '') {
                this.ifTree = false;
            }
            if (this.isSelect) {
                // 查询框机构
                this.groupName = unit.name;
                if (this.groupName !== '全部') {
                    // 如果不是选中根节点时，进行设置，否则，就忽略
                    this.form.groupId = unit.id;
                    this.groupChildList = unit.childList;
                } else {
                    // 若选中根节点，查询所有机构
                    this.form.groupId = '';
                }
            } else {
                // “新增”或“编辑”选择机构
                this.$refs.Addchild.addPage(unit);
            }
            this.hideTree();
        },
        /**
         * @author: liuc
         * @description:点击用户机构查询框，显示机构弹窗
         * @param {}
         */
        showTreeforSelect () {
            this.ifTree = true;
            this.isTree = true;
            this.isSelect = true;
        },
        /**
         * @author: liuc
         * @description: 获取表格数据
         * @param {queryBean} 请求接口参数
         */
        loadTable (queryBean) {
            this.$refs.UserList.loadTable(queryBean);
        },
        /** @author: liuc
         * @description: 刷新表格
         * @param {operateType} 判断是否为success
         */
        async closeAddModal (operateType) {
            if (operateType === 'success') {
                // 刷新表格
                await this.$refs.UserList.loadTableRefresh();
            }
        },
        /**
         * @author: liuc
         * @description: 查询列表
         * @param {type} currentPage 跳转页
         */
        loadlist (currentPage) {
            global.loading.select = true;
            let filters = [];
            let groupIds = [];
            let nickname = this.tableSearchNode(
                'nickname',
                'like',
                [this.form.nickname],
                'String'
            );
            let username = this.tableSearchNode(
                'username',
                'like',
                [this.form.username.replace(/_/g, '\\_')],
                'String'
            );
            let email = this.tableSearchNode(
                'email',
                'like',
                [this.form.email],
                'String'
            );
            let groupId = this.tableSearchNode(
                'groupId',
                'eq',
                [this.form.groupId],
                'String'
            );
            let roleid = this.tableSearchNode(
                'roleid',
                'eq',
                [this.form.roleid],
                'String'
            );
            let status = this.tableSearchNode(
                'status',
                'eq',
                [this.form.status],
                'String'
            );
            groupIds.push(groupId);
            // 若所选机构下有子机构，遍历子节点，获取所有子节点id
            if (this.isNotNull(this.groupChildList)) {
                let groupIdList = this.getGroupChildList(this.groupChildList);
                groupIdList.forEach(element => {
                    groupId = this.tableSearchNode(
                        'groupId',
                        'eq',
                        [element],
                        'String'
                    );
                    groupIds.push(groupId);
                });
            }
            filters.push([nickname]);
            filters.push([username]);
            filters.push([email]);
            filters.push(groupIds);
            filters.push([roleid]);
            filters.push([status]);
            let queryBean = this.buildQueryBean(
                currentPage,
                this.pageSize,
                filters
            );
            this.loadTable(queryBean);
        },
        /**
         * @author: liuc
         * @description: 获取所选机构的所有子机构的groupId,
         * @param {list} 机构的子机构
         */
        getGroupChildList (list) {
            let groupIdList = [];
            for (let index = 0; index < list.length; index++) {
                groupIdList.push(list[index].id);
                if (list[index].childList != null) {
                    groupIdList = groupIdList.concat(
                        this.getGroupChildList(list[index].childList)
                    );
                }
            }
            return groupIdList;
        },
        /**
         * @author: liuc
         * @description: 获取所有角色列表,用于角色下拉框
         * @param {type}
         */
        async grtRoleList () {
            let response = await this.$api.UserManagement.queryNotInRole({
                id: null
            });
            this.roleList = response.data;
        },
        /**
         * @author: liuc
         * @description:重置
         * @param {}
         */
        resetForm () {
            this.$refs.form.resetFields();
            this.groupName = '全部';
            this.groupChildList = [];
            this.loadlist();
        },
        /**
         * @author: liuc
         * @description: 判断传入的值是否为空
         * @param {target} 传入的内容
         */
        isNotNull (target) {
            if (target) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @author: liuc
         * @description: 人员管理查询表单显示隐藏
         * @param {}
         */
        shiftFormShow () {
            if (this.formShow) {
                this.formShow = false;
            } else {
                this.formShow = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.el-header {
    font-size: 24px;
}
.con-f-div {
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .top {
        border: 1px solid #e1e8e9;
        margin-right: 29px;
        .top-header {
            display: flex;
            align-items: center;
            height: 70px;
            padding-left: 29px;
            background: #f4f7fb;
            .header-content {
                flex: 1;
                display: flex;
                align-items: center;
                .header-content-title {
                    font-size: 24px;
                    font-weight: 400;
                    color: #333;
                }
            }
        }
        .top-content {
            width: 80%;
            padding-top: 20px;
            padding-left: 29px;
            .el-form-item {
                margin-bottom: 10px;
                /deep/ .el-input {
                    width: 320px;
                }
            }
        }
        .top-footer {
            border-top: 1px solid #e1e8e9;
            padding: 10px 20px;
            overflow: hidden;
            .left-btn {
                float: left;
            }
            .right-btn {
                float: right;
                .reset-btn {
                    background: #fff;
                    color: #4970ad;
                }
            }
        }
    }
    .list {
        flex: 1;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// ./src/views/UserManagement.vue